import DynamicContentsView from './DynamicContentsView';

export default DynamicContentsView;
